module.exports = __webpack_public_path__ + "img/thumb2.fd6df9e0.png";